export const CONFIRMATION_MODAL_OPEN = 'CONFIRMATION_MODAL_OPEN';
export const confirmationModalOpen = confirmationModalID => ({
  type: CONFIRMATION_MODAL_OPEN,
  confirmationModalID,
});
export const CONFIRMATION_MODAL_CLOSE = 'CONFIRMATION_MODAL_CLOSE';
export const confirmationModalClose = () => ({
  type: CONFIRMATION_MODAL_CLOSE,
});
